"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendMessage = exports.notifciationReducer = exports.markNotificationAsRemoveById = exports.markNotificationAsReadById = exports.getUnreadNotifcations = exports.getNotificationById = exports.getAnnouncement = exports.getAllNotifications = exports.default = void 0;

require("core-js/modules/es.global-this.js");

require("core-js/modules/es.promise.js");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _notification = require("./actions/notification");

var _announcement = require("./api/announcement/announcement");

var _header = require("./api/header/header");

var _notification2 = require("./api/notification/notification");

var _Socket = _interopRequireDefault(require("./components/Socket/Socket"));

var _notification3 = _interopRequireDefault(require("./reducer/notification"));

var _reactToastify = require("react-toastify");

require("react-toastify/dist/ReactToastify.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class NotificationSDK extends _react.Component {
  componentDidMount() {
    globalThis.notificationSdkRef = this.props;
    (0, _header.getHeadersApi)(this.props.apiBasePath, this.props.projectKey).then(_ref => {
      let {
        data
      } = _ref;
      this.props.setHeaderList(data);
    }).catch(e => {});

    if (this.props.authToken !== undefined && this.props.authToken !== null) {
      (0, _notification2.getUnreadNotifcationsApi)(this.props.apiBasePath, this.props.authToken, this.props.projectKey).then(_ref2 => {
        let {
          data
        } = _ref2;
        this.props.setUnreadNotificationList(data);
      }).catch(e => {});
      (0, _notification2.getAllNotifcationsApi)(this.props.apiBasePath, this.props.authToken, this.props.projectKey).then(_ref3 => {
        let {
          data
        } = _ref3;
        this.props.setAllNotificationList(data);
      }).catch(e => {});
      (0, _announcement.getAnnouncementApi)(this.props.apiBasePath, this.props.authToken, this.props.projectKey).then(_ref4 => {
        let {
          data
        } = _ref4;
        this.props.setAnnouncementList(data);
      }).catch(e => {});
    }
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Socket.default, {
      apiBasePath: this.props.apiBasePath,
      connectionURL: this.props.connectionURL,
      projectKey: this.props.projectKey,
      userAuthToken: this.props.authToken
    }), /*#__PURE__*/_react.default.createElement(_reactToastify.ToastContainer, null));
  }

}

const mapStateToProps = state => ({
  notifications: state.Notification.notifications
});

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  setAllNotificationList: _notification.setAllNotificationList,
  setAnnouncementList: _notification.setAnnouncementList,
  setUnreadNotificationList: _notification.setUnreadNotificationList,
  setHeaderList: _notification.setHeaderList,
  setNotificationAllUnreadCheck: _notification.setNotificationAllUnreadCheck,
  setNotificationUnreadCheck: _notification.setNotificationUnreadCheck,
  setNotificationMarkAsRead: _notification.setNotificationMarkAsRead,
  setRemoveNotificationById: _notification.setRemoveNotificationById
})(NotificationSDK);

exports.default = _default;
const notifciationReducer = _notification3.default;
/**
 * @param {Number} page 
 * @returns {Promise} 
 */

exports.notifciationReducer = notifciationReducer;

const getAllNotifications = function getAllNotifications() {
  let page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return new Promise((resolve, reject) => {
    (0, _notification2.getAllNotifcationsApi)(globalThis.notificationSdkRef.apiBasePath, globalThis.notificationSdkRef.authToken, globalThis.notificationSdkRef.projectKey, page).then(_ref5 => {
      let {
        data
      } = _ref5;
      globalThis.notificationSdkRef.setAllNotificationList(data);
      resolve();
    }).catch(reject);
  });
};
/**
 * @param {Number} page 
 * @returns {Promise} 
 */


exports.getAllNotifications = getAllNotifications;

const getUnreadNotifcations = function getUnreadNotifcations() {
  let page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return new Promise((resolve, reject) => {
    (0, _notification2.getUnreadNotifcationsApi)(globalThis.notificationSdkRef.apiBasePath, globalThis.notificationSdkRef.authToken, globalThis.notificationSdkRef.projectKey, page).then(_ref6 => {
      let {
        data
      } = _ref6;
      globalThis.notificationSdkRef.setUnreadNotificationList(data);
      resolve();
    }).catch(reject);
  });
};
/**
 * @param {Number} page 
 * @returns {Promise} 
 */


exports.getUnreadNotifcations = getUnreadNotifcations;

const getAnnouncement = function getAnnouncement() {
  let page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return new Promise((resolve, reject) => {
    (0, _announcement.getAnnouncementApi)(globalThis.notificationSdkRef.apiBasePath, globalThis.notificationSdkRef.authToken, globalThis.notificationSdkRef.projectKey, page).then(_ref7 => {
      let {
        data
      } = _ref7;
      globalThis.notificationSdkRef.setAnnouncementList(data);
      resolve();
    }).catch(reject);
  });
};
/**
 * @param {Number} id 
 * @returns {Promise} 
 */


exports.getAnnouncement = getAnnouncement;

const getNotificationById = function getNotificationById() {
  let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return new Promise((resolve, reject) => {
    const notification = globalThis.notificationSdkRef.notifications.all.data.filter(_ => _.id == id);

    if (notification.length > 0) {
      resolve(notification[0]);
    } else {
      (0, _notification2.getNotificationByIdApi)(globalThis.notificationSdkRef.apiBasePath, globalThis.notificationSdkRef.authToken, globalThis.notificationSdkRef.projectKey, id).then(_ref8 => {
        let {
          data: {
            data
          }
        } = _ref8;
        resolve(data.length > 0 ? data[0] : null);

        if (data.length > 0 && !data[0].userpreferences.is_read && data[0].category !== 'announcement') {
          markNotificationAsReadById(id);
        }
      }).catch(reject);
    }
  });
};
/**
 * @param {Number} id 
 * @returns {Promise} 
 */


exports.getNotificationById = getNotificationById;

const markNotificationAsReadById = function markNotificationAsReadById() {
  let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return new Promise(async (resolve, reject) => {
    (0, _notification2.markNotificationAsReadApi)(globalThis.notificationSdkRef.apiBasePath, globalThis.notificationSdkRef.authToken, globalThis.notificationSdkRef.projectKey, id).then(_ref9 => {
      let {
        data
      } = _ref9;
      resolve();
      globalThis.notificationSdkRef.setNotificationMarkAsRead(id);
    }).catch(reject);
  });
};
/**
 * @param {Number} id 
 * @returns {Promise} 
 */


exports.markNotificationAsReadById = markNotificationAsReadById;

const markNotificationAsRemoveById = function markNotificationAsRemoveById() {
  let id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return new Promise(async (resolve, reject) => {
    globalThis.notificationSdkRef.setRemoveNotificationById(id);
    (0, _notification2.removeNotificationByIdApi)(globalThis.notificationSdkRef.apiBasePath, globalThis.notificationSdkRef.authToken, globalThis.notificationSdkRef.projectKey, id).then(_ref10 => {
      let {
        data
      } = _ref10;
      resolve();
    }).catch(reject);
  });
};
/**
 * @param connetion {Object}
 * @param payload {Object}
 */


exports.markNotificationAsRemoveById = markNotificationAsRemoveById;

const sendMessage = (connection, payload) => {
  connection.send(payload);
};

exports.sendMessage = sendMessage;